import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsule } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSULE: TIdToPageConfigMap = {
  [PageIdStylioCapsule.AGE_CAPSULE]: {
    id: PageIdStylioCapsule.AGE_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapsule.URGE_CAPSULE]: {
    id: PageIdStylioCapsule.URGE_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.HAIR_COLOR_CAPSULE]: {
    id: PageIdStylioCapsule.HAIR_COLOR_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.EYES_COLOR_CAPSULE]: {
    id: PageIdStylioCapsule.EYES_COLOR_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.JEWELRY_CAPSULE]: {
    id: PageIdStylioCapsule.JEWELRY_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.BODY_SHAPE_CAPSULE]: {
    id: PageIdStylioCapsule.BODY_SHAPE_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.OUTFIT_STRUGGLES_CAPSULE]: {
    id: PageIdStylioCapsule.OUTFIT_STRUGGLES_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.STYLIO_TO_HELP_CAPSULE]: {
    id: PageIdStylioCapsule.STYLIO_TO_HELP_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.TALL_CAPSULE]: {
    id: PageIdStylioCapsule.TALL_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.WEIGHT_CAPSULE]: {
    id: PageIdStylioCapsule.WEIGHT_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.BODY_COMFORT_CAPSULE]: {
    id: PageIdStylioCapsule.BODY_COMFORT_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.WHAT_YOU_WEAR_CAPSULE]: {
    id: PageIdStylioCapsule.WHAT_YOU_WEAR_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.URGE_2_CAPSULE]: {
    id: PageIdStylioCapsule.URGE_2_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.FEEL_ABOUT_CAPSULE]: {
    id: PageIdStylioCapsule.FEEL_ABOUT_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.WARDROBE_USAGE_CAPSULE]: {
    id: PageIdStylioCapsule.WARDROBE_USAGE_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.NOT_ALONE_CAPSULE]: {
    id: PageIdStylioCapsule.NOT_ALONE_CAPSULE,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioCapsule.PERCENTAGE_CAPSULE]: {
    id: PageIdStylioCapsule.PERCENTAGE_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.SHOPPING_CAPSULE]: {
    id: PageIdStylioCapsule.SHOPPING_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.STYLE_MOST_MATTERS_CAPSULE]: {
    id: PageIdStylioCapsule.STYLE_MOST_MATTERS_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.YOUR_LOCATION_CAPSULE]: {
    id: PageIdStylioCapsule.YOUR_LOCATION_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.FAVORITE_COLORS_CAPSULE]: {
    id: PageIdStylioCapsule.FAVORITE_COLORS_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_11_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_11_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_12_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_12_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_13_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_13_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_14_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_14_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_15_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_15_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_16_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_16_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_17_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_17_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_18_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_18_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.LIKE_OR_DISLIKE_19_CAPSULE]: {
    id: PageIdStylioCapsule.LIKE_OR_DISLIKE_19_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.SEE_YOURSELF_CAPSULE]: {
    id: PageIdStylioCapsule.SEE_YOURSELF_CAPSULE,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioCapsule.STYLES_FEEL_LIKE_YOU_CAPSULE]: {
    id: PageIdStylioCapsule.STYLES_FEEL_LIKE_YOU_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.URGE_4_CAPSULE]: {
    id: PageIdStylioCapsule.URGE_4_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.WHAT_YOU_WILL_FIND_CAPSULE]: {
    id: PageIdStylioCapsule.WHAT_YOU_WILL_FIND_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.BRAND_CAPSULE]: {
    id: PageIdStylioCapsule.BRAND_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.FIND_NEW_CLOTHES_CAPSULE]: {
    id: PageIdStylioCapsule.FIND_NEW_CLOTHES_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.NOTHING_TO_WEAR_CAPSULE]: {
    id: PageIdStylioCapsule.NOTHING_TO_WEAR_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.OLD_CLOTHES_CAPSULE]: {
    id: PageIdStylioCapsule.OLD_CLOTHES_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.COMBINE_CLOTHES_CAPSULE]: {
    id: PageIdStylioCapsule.COMBINE_CLOTHES_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.OPTIMIZE_BUDGET_CAPSULE]: {
    id: PageIdStylioCapsule.OPTIMIZE_BUDGET_CAPSULE,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsule.URGE_3_CAPSULE]: {
    id: PageIdStylioCapsule.URGE_3_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.PREPARE_FLOW_CAPSULE]: {
    id: PageIdStylioCapsule.PREPARE_FLOW_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.EMAIL_CAPSULE]: {
    id: PageIdStylioCapsule.EMAIL_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.EMAIL_CONSENT_CAPSULE]: {
    id: PageIdStylioCapsule.EMAIL_CONSENT_CAPSULE,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsule.SUBSCRIPTIONS_CAPSULE]: {
    id: PageIdStylioCapsule.SUBSCRIPTIONS_CAPSULE,
  },
  [PageIdStylioCapsule.CANCEL_OFFER_CAPSULE]: {
    id: PageIdStylioCapsule.CANCEL_OFFER_CAPSULE,
  },
  [PageIdStylioCapsule.SUB_UPSELL_CAPSULE]: {
    id: PageIdStylioCapsule.SUB_UPSELL_CAPSULE,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule.UPSELL_CAPSULE]: {
    id: PageIdStylioCapsule.UPSELL_CAPSULE,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule.THIRD_PDF_UPSELL_CAPSULE]: {
    id: PageIdStylioCapsule.THIRD_PDF_UPSELL_CAPSULE,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule.BUNDLE_UPSELL_CAPSULE]: {
    id: PageIdStylioCapsule.BUNDLE_UPSELL_CAPSULE,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsule.DOWNLOAD_CAPSULE]: {
    id: PageIdStylioCapsule.DOWNLOAD_CAPSULE,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
